import BaseClient from '@/app/model/api/response/baseApiClient'
import { fieldDetailsApiFlag } from '@/app/model/store/domain/const'

class FieldSortApi extends BaseClient {
  public doFieldSort (flag: number, searchList: {[key:string]: any}, ownerList: number[]) {
    const path = '/v1/field/list'
    var url = new URL(process.env.VUE_APP_API_URL + path)
    var params = new URLSearchParams({ request_type: '0' })

    if (flag === fieldDetailsApiFlag.FLAG_FIELD) {
      // 圃場検索の場合
      params.append('request_type', '0')
      if (searchList.refile) {
        params.append('is_plant', '0')
      } else {
        params.append('is_plant', '1')
      }
      if (searchList.status !== '' && searchList.status !== 0) {
        params.append('growth_stage_id', searchList.status)
      }
      if (searchList.variety !== '') {
        params.append('variety_id', searchList.variety)
      }
      if (searchList.risk !== 0) {
        params.append('risk_id', String(searchList.risk))
      }
      if (searchList.word !== '') {
        params.append('word', String(searchList.word))
      }
      params.append('is_polygon', '1')
      params.append('accordion_id', String(searchList.target))
      url.search = params.toString()
    } else if (flag === fieldDetailsApiFlag.FLAG_MODAL) {
      params.append('request_type', '0')
      params.append('is_plant', '1')
      if (searchList.status !== '') {
        params.append('growth_stage_id', searchList.status)
      }
      if (searchList.variety !== '') {
        params.append('variety_name', searchList.variety)
      }
      if (searchList.grade !== '') {
        params.append('grade_name', searchList.grade)
      }
      if (searchList.risk !== 0) {
        params.append('risk_id', String(searchList.risk))
      }
      if (searchList.word !== '') {
        params.append('word', String(searchList.word))
      }
      for (var j in ownerList) {
        params.append('field_id[]', String(ownerList[j]))
      }
      url.search = params.toString()
    } else if (flag === fieldDetailsApiFlag.FLAG_FIELD_TARGET) {
      params.append('request_type', '0')
      if (searchList.refile) {
        params.append('is_plant', '0')
      } else {
        params.append('is_plant', '1')
      }
      if (searchList.status !== '' && searchList.status !== 0) {
        params.append('growth_stage_id', searchList.status)
      }
      if (searchList.variety !== '') {
        params.append('variety_id', searchList.variety)
      }
      if (searchList.risk !== 0) {
        params.append('risk_id', String(searchList.risk))
      }
      if (searchList.word !== '') {
        params.append('word', String(searchList.word))
      }
      params.append('is_polygon', '1')
      // ターゲットの修正
      if (searchList.target !== '') {
        params.append('accordion_id', searchList.target)
      }
      url.search = params.toString()
    }

    /* 共通処理 */
    return super.doFetch(decodeURI(url.href), 'GET')
  }
}

export default new FieldSortApi()
